import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";
import styles from "../drawer.module.scss";
import { useToken } from "../../../../hooks/useToken";
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import TableChartRoundedIcon from '@mui/icons-material/TableChartRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import {
  SettingFilled,
  HomeFilled,
  ProfileFilled,
  IdcardFilled,
  LogoutOutlined,
} from "@ant-design/icons";

export const NonAdminList = ({ toggleDrawer, typeUser, operations }) => {
  const [token, { saveToken }] = useToken();
  const handleLogout = () => {
    saveToken(null);
    sessionStorage.removeItem("valueKanban");
    sessionStorage.removeItem("updateKanban");
    sessionStorage.removeItem("valueKanbanLabel");
    sessionStorage.removeItem("intervalUpatedCards");
    sessionStorage.removeItem("id_update_chart_farm");
    sessionStorage.removeItem("id_interval_sensorChart");
    sessionStorage.removeItem("valueTypeOperationCards");
    sessionStorage.removeItem("valueTypeOperationKanban");
    sessionStorage.removeItem("typeOperationUser");
    window.location.href = "/login";
  };

  return (
    <List className={styles.list} component="nav">

      <Link className={styles.listLink} to="/" onClick={toggleDrawer}>
        <ListItemButton>
          <ListItemIcon>
            <HomeFilled className={styles.icons} />
          </ListItemIcon>
          <ListItemText className={styles.listItemText} primary="Home" />
        </ListItemButton>
      </Link>

      {operations === 'GRANJAS'?
        <></>
        :
        <Link className={styles.listLink} to="/cards" onClick={toggleDrawer}>
          <ListItemButton>
            <ListItemIcon>
              <DashboardRoundedIcon
                className={styles.listItemIcon}
                primary="Cards"
              ></DashboardRoundedIcon>
            </ListItemIcon>
            <ListItemText className={styles.listItemText} primary="Cards" />
          </ListItemButton>
        </Link>

      }

      {
        operations === 'GRANJAS' ?
          <></>
          :
          <Link className={styles.listLink} to="/kanban" onClick={toggleDrawer}>
            <ListItemButton>
              <ListItemIcon>
                <TableChartRoundedIcon
                  className={styles.listItemIcon}
                  primary="Kanban"
                >
                </TableChartRoundedIcon>
              </ListItemIcon>
              <ListItemText className={styles.listItemText} primary="Kanban" />
            </ListItemButton>
          </Link>
      }

      {typeUser === "Usuário" ?
        <></>
        :
        <Link className={styles.listLink} to="/vehicles" onClick={toggleDrawer}>
          <ListItemButton>
            <ListItemIcon>
              <SettingFilled className={styles.icons} />
            </ListItemIcon>
            <ListItemText
              className={styles.listItemText}
              primary="Configurações"
            />
          </ListItemButton>
        </Link>
      }

      {typeUser === "Administrador" ?
        <Link className={styles.listLink} to="/users" onClick={toggleDrawer}>
          <ListItemButton>
            <ListItemIcon>
              <PeopleAltRoundedIcon className={styles.icons} />
            </ListItemIcon>
            <ListItemText className={styles.listItemText} primary="Usuários" />
          </ListItemButton>
        </Link>
        :
        <></>
      }

      {typeUser !== "Administrador" ?
        <></>
        :
        <Link className={styles.listLink} to="/drivers" onClick={toggleDrawer}>
          <ListItemButton>
            <ListItemIcon>
              <IdcardFilled className={styles.icons} />
            </ListItemIcon>
            <ListItemText className={styles.listItemText} primary="Motoristas" />
          </ListItemButton>
        </Link>
      }

      <Link className={styles.listLink} to="/reports" onClick={toggleDrawer}>
        <ListItemButton>
          <ListItemIcon>
            <ProfileFilled className={styles.icons} />
          </ListItemIcon>
          <ListItemText className={styles.listItemText} primary="Relatórios" />
        </ListItemButton>
      </Link>


      <Link className={styles.listLink} to="/login" onClick={handleLogout}>
        <ListItemButton>
          <ListItemIcon>
            <LogoutOutlined className={styles.icons} />
          </ListItemIcon>
          <ListItemText className={styles.listItemText} primary="Sair" />
        </ListItemButton>
      </Link>
    </List>
  );
};
